var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-facebook-login',{attrs:{"app-id":_vm.facebook.appId,"button-style":{margin:'0 auto'},"login-options":_vm.facebook.loginOptions,"version":_vm.facebook.version},on:{"connect":_vm.facebookLogin,"logout":_vm.facebookLogout,"sdk-init":_vm.facebookInit}})}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-681fa455","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Assets/components/Users/LoginOrSignup/FacebookLogin.vue
// module id = 843
// module chunks = 1 2